import {
  ExpressCheckoutElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useFetchPlans } from "../hooks/useFetchPlans";
import { useNavigate } from "react-router";
import { errorToast, successToast } from "@utils/toaster";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import { axiosInstance } from "@api/index";
import { usePaymentButtonMethod } from "../hooks/usePaymentMethod";
import { updateDataLayer } from "@utils/updateDataLayer";
import { apphud } from "@utils/apphud";
import { updateApphudTracking } from "@api/services/authService";

export const PaymentButton = ({ id, isWalky }) => {
  const { paymentMethod } = usePaymentButtonMethod();

  const user = useSelector((state) => state.user.userInfo);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const { initiatePayment, activePlan } = useFetchPlans();

  const onCancel = () => {
    updateDataLayer({
      event: "checkout_cancel",
      paymentMethod: paymentMethod,
      currency: activePlan.currency,
      amount: +activePlan.priceAmount / 100,
      product_name: activePlan.title,
    });
  };

  let currentSubscriptionId;

  const onConfirm = async () => {
    console.log("cofirm");
    if (!stripe) {
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      errorToast({ message: submitError.message });
      return;
    }

    const getStripeClientSecret = async () => {
      try {
        const { stripeClientSecret, subscriptionId } = await initiatePayment({
          paymentMethod: paymentMethod,
          paymentProvider: "STRIPE",
        });
        currentSubscriptionId = subscriptionId;
        return stripeClientSecret;
      } catch (error) {
        errorToast({ message: error.response.data.message });
      }
    };

    const clientSecret = await getStripeClientSecret();

    const payload = await stripe.confirmPayment({
      elements,
      clientSecret,
      redirect: "if_required",
      confirmParams: {
        return_url: "https://easyfit.me",
      },
    });

    if (payload.error) {
      errorToast({ message: payload.error.message });
    } else {
      await axiosInstance.post("/auth/send-pin-to-email", {
        email: user?.email,
      });

      const userId = localStorage.getItem("userId");

      updateDataLayer({
        event: "Purchase",
        paymentMethod: paymentMethod,
        product_name: activePlan.title,
        currency: activePlan.currency,
        amount: +activePlan.priceAmount / 100,
        userId,
        subscriptionId: currentSubscriptionId,
      });

      if (isWalky) {
        navigate("/activate");
      } else {
        navigate("/upsale");
      }
      successToast({ message: "Payment successful! Thank you!" });
    }
  };

  const handleClick = (event) => {
    const buttonType = event.expressPaymentType;

    const isTrial = localStorage.getItem("isTrial") === "true";

    updateDataLayer({
      event: "checkout_initiated",
      paymentMethod: buttonType?.toUpperCase(),
      currency: activePlan.currency,
      amount: isTrial
        ? +activePlan.trialPriceAmount / 100
        : +activePlan.priceAmount / 100,
      product_name: activePlan.title,
    });

    event.resolve();
  };

  return (
    <>
      <ExpressCheckoutElement
        className={`${styles.payButton} ${id}`}
        options={{
          buttonHeight: 52,
          paymentMethods: { applePay: "always" },
        }}
        onClick={handleClick}
        onConfirm={onConfirm}
        data-testid="express-checkout-element"
        onCancel={onCancel}
      />
    </>
  );
};
